import { useEffect, useState } from "react";

// useState backed by localStorage. null/undefined removes the key.
export default function usePersistedState(
  key,
  initialValue,
  { parse = (value) => value, serialize = String } = {},
) {
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved === null ? initialValue : parse(saved);
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      if (value === null || value === undefined) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, serialize(value));
      }
    } catch {
      // Storage unavailable (private mode, quota): state still works in memory.
    }
  }, [key, value, serialize]);

  return [value, setValue];
}
